/**
 * - pause = Pauses playing the current Orbit.
 * - reset = The requesting entity intends to reset orbit mode to its first frame.
 */
export var ModifyOrbit;
(function (ModifyOrbit) {
    ModifyOrbit["pause"] = "pause";
    ModifyOrbit["reset"] = "reset";
})(ModifyOrbit || (ModifyOrbit = {}));
//# sourceMappingURL=modify-orbit.js.map